import { getValueFromLs } from '@/shared/services/localstorage';
import { EDITOR_LS_CONSTANTS } from '@/editor/shared/constants/editor-LS.constants';
import { PlatformType } from '@/editor/shared/constants/available-platforms';
import { CreativeType } from '@/editor/shared/constants/creatives-types.enum';

const safeParse = <T>(value: string | null | undefined, fallback: T): T => {
  if (!value) return fallback;
  try {
    return JSON.parse(value);
  } catch (error) {
    console.error('Failed to parse localStorage value:', error);
    return fallback;
  }
};

export const loadStateFromLocalStorage = () => {
  const adsetFormStr = getValueFromLs(EDITOR_LS_CONSTANTS.ADSET_FORM);
  const platformsStr = getValueFromLs(EDITOR_LS_CONSTANTS.ACTIVE_SOCIAL_MEDIA_PLATFORMS);
  const selectedCreativeType = getValueFromLs(EDITOR_LS_CONSTANTS.SELECTED_CREATIVE_TYPE);
  const propertyAddress = getValueFromLs(EDITOR_LS_CONSTANTS.PROPERTY_ADDRESS);
  const orderTitle = getValueFromLs(EDITOR_LS_CONSTANTS.ORDER_TITLE);
  const propertyInternalId = getValueFromLs(EDITOR_LS_CONSTANTS.PROPERTY_INTERNAL_ID);
  const propertyExternalId = getValueFromLs(EDITOR_LS_CONSTANTS.PROPERTY_EXTERNAL_ID);
  const companyId = getValueFromLs(EDITOR_LS_CONSTANTS.COMPANY_ID);

  const creativeForms: Record<string, any> = {};

  Object.entries(EDITOR_LS_CONSTANTS.CREATIVES_FORMS).forEach(([platform, lsKey]) => {
    const formStr = getValueFromLs(lsKey);
    if (formStr) {
      const formData = safeParse(formStr, null);
      if (formData) {
        creativeForms[platform] = formData;
      }
    }
  });

  return {
    adsetForm: adsetFormStr ? safeParse(adsetFormStr, null) : null,
    activePlatforms: platformsStr ? safeParse<PlatformType[]>(platformsStr, []) : null,
    selectedCreativeType: (selectedCreativeType as CreativeType) || null,
    creativeForms: Object.keys(creativeForms).length > 0 ? creativeForms : null,
    propertyInfo: {
      companyId: companyId ?? '',
      propertyAddress: propertyAddress ?? '',
      orderTitle: orderTitle ?? '',
      propertyInternalId: propertyInternalId ?? '',
      propertyExternalId: propertyExternalId ?? '',
    },
  };
};
